module.exports = __webpack_public_path__ + "static/hr-0d0d251acf508f9cd8566f4457473db7.svg";